import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { getStories, Story } from '../api/stories'

const StoriesPage = () => {
  const [stories, setStories] = useState<Story[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchStories = async () => {
      try {
        const data = await getStories()
        setStories(data)
      } catch (error) {
        console.error('Error fetching stories:', error)
      } finally {
        setLoading(false)
      }
    }

    fetchStories()
  }, [])

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    })
  }

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading stories...</p>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-900 mb-6 text-center">Stories</h1>
        <p className="text-gray-600 mb-10 text-center">Read inspiring stories from our volunteers, suppliers, and food banks.</p>
        
        {stories.length === 0 ? (
          <div className="text-center py-12">
            <div className="text-6xl mb-4">📝</div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">No Stories Yet</h3>
            <p className="text-gray-600 mb-6">
              Be the first to share your story with the community!
            </p>
            <Link
              to="/stories/create"
              className="btn-primary inline-flex items-center"
            >
              Write Your Story
            </Link>
          </div>
        ) : (
          <div className="space-y-8">
            {stories.map((story) => (
              <div key={story.id} className="bg-white rounded-lg shadow p-6">
                <h2 className="text-2xl font-semibold text-primary-700 mb-2">{story.title}</h2>
                <div className="text-sm text-gray-500 mb-2">
                  By {story.authorName} &middot; {formatDate(story.createdAt)}
                </div>
                <p className="text-gray-800 mb-4">
                  {story.excerpt || story.content.substring(0, 200) + '...'}
                </p>
                <Link to={`/stories/${story.id}`} className="text-primary-600 hover:underline text-sm">
                  Read more
                </Link>
              </div>
            ))}
          </div>
        )}

        {/* Call to Action */}
        <div className="text-center mt-12">
          <Link
            to="/stories/create"
            className="btn-primary inline-flex items-center"
          >
            Share Your Story
          </Link>
        </div>
      </div>
    </div>
  )
}

export default StoriesPage 